import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Experience } from "@/components/site/Experience";
import { Menu } from "@/components/site/Menu";
import { Gallery } from "@/components/site/Gallery";
import { Reservation } from "@/components/site/Reservation";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (id) => {
    if (id === "top") {
      lenisRef.current?.scrollTo(0, { duration: 1.2 });
      return;
    }
    const el = document.getElementById(id);
    if (el) lenisRef.current?.scrollTo(el, { offset: -70, duration: 1.3 });
  };

  const reserve = () => scrollTo("reserve");

  return (
    <div className="grain min-h-screen bg-[var(--br-black)]">
      <Navbar onReserve={reserve} scrollTo={scrollTo} />
      <Hero onReserve={reserve} scrollTo={scrollTo} />
      <Marquee />
      <Experience />
      <Gallery />
      <Menu />
      <Reservation />
      <Footer onReserve={reserve} />
    </div>
  );
}
